var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRemoveRequest = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000160217 160H106.667V26.667H33.3332L-0.000160217 58.413V160Z",
    fill: "#BBDEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76168 61.5874H34.9204V31.4287L4.76168 61.5874Z",
    fill: "#64B5F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 86.667H79.9998V94.286H26.6665V86.667ZM26.6665 101.905H67.4508V109.524H26.6665V101.905ZM26.6665 117.143H79.9998V124.762H26.6665V117.143ZM26.6665 132.381H67.4508V140H26.6665V132.381Z",
    fill: "#64B5F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.333 46.667C153.333 68.757 135.423 86.667 113.333 86.667C91.2435 86.667 73.3335 68.757 73.3335 46.667C73.3335 24.577 91.2435 6.66699 113.333 6.66699C135.423 6.66699 153.333 24.577 153.333 46.667Z",
    fill: "#F43E3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1906 65.7143C96.1906 68.8571 98.7621 71.4286 101.905 71.4286H124.762C127.905 71.4286 130.476 68.8571 130.476 65.7143V37.1429C130.476 34 127.905 31.4286 124.762 31.4286H101.905C98.7621 31.4286 96.1906 34 96.1906 37.1429V65.7143ZM104.762 37.1429H121.905C123.476 37.1429 124.762 38.4286 124.762 40V62.8571C124.762 64.4286 123.476 65.7143 121.905 65.7143H104.762C103.191 65.7143 101.905 64.4286 101.905 62.8571V40C101.905 38.4286 103.191 37.1429 104.762 37.1429ZM123.333 22.8571L121.305 20.8286C120.791 20.3143 120.048 20 119.305 20H107.362C106.619 20 105.876 20.3143 105.362 20.8286L103.333 22.8571H96.1906C94.6192 22.8571 93.3335 24.1429 93.3335 25.7143C93.3335 27.2857 94.6192 28.5714 96.1906 28.5714H130.476C132.048 28.5714 133.333 27.2857 133.333 25.7143C133.333 24.1429 132.048 22.8571 130.476 22.8571H123.333Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRemoveRequest, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RemoveRequest.56dc859d.svg";
export { ForwardRef as ReactComponent };